import SocialLinks from './SocialLinks';

export { type SocialLinksProps } from './SocialLinks';
export default SocialLinks;
